<template>
    <div>
        <download-file :isShowDownloadIcon="true" :title="this.$t('storeToolMgnView.guide') +'.pdf'" uatId="166996a60c5d0899abba8454253b58dc"
                       proId="166996ddf3c55d96b0ce150473ca151f"></download-file>
        <Card dis-hover :bordered="false">
            <Form ref="qryConForm" :label-width="110">
                <Row type="flex">
                    <Col span="8">
                        <FormItem :label="qryConForm.Labels.storeOrg" :required="true">
                            <Select v-model="storeOrg" size="small" @on-change="changeOrg()">
                                <Option v-for="item in qryConForm_storeOrgList" :value="item.value" :key="item.value">{{
                                    item.label }}
                                </Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem :label="qryConForm.Labels.createDate" :required="true">
                            <Select v-model="createDate" size="small">
                                <Option v-for="item in createDateList" :value="item.value" :key="item.value">{{
                                    item.label }}
                                </Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem :label="qryConForm.Labels.commentTxt">
                            <Input type="textarea" v-model="commentTxt" :rows="1" size="small"/>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <Button type="primary" @click="addBtnClick" style="margin-left: 6px;width: 80px;padding: 5px;"
                    v-show="showBtn">{{ this.$t('storeToolMgnView.newBtn')
                }}
            </Button>
            <Button type="primary" :loading="saveStoreLoading" @click="saveBtnClick" style="margin-left: 6px;width: 80px;padding: 5px;">{{
                this.$t('storeToolMgnView.saveBtn') }}
            </Button>
            <Button type="primary" @click="batchLoadBtnClick_openModal"
                    style="margin-left: 6px;width: 100px;padding: 5px;" v-show="showBtn">{{
                this.$t('storeToolMgnView.batchLoadBtn') }}
            </Button>
            <Button type="primary" @click="uploadModal = true"
                    style="margin-left: 6px;width: 100px;padding: 5px;" v-show="showBtn2">{{this.$t('storeToolMgnModel.multiTapInveImport')}}</Button>
            <div style="margin-left:6px;">
                <strong>{{this.$t('storeToolMgnView.tipsTransactionTypeDesc')}}</strong><br/>
                <strong>{{this.$t('storeToolMgnView.tipsTitleA')}}</strong>{{this.$t('storeToolMgnView.tipsTitleTxtA')}}<br/>
                {{this.$t('storeToolMgnView.tipsEgA1')}}<br/>
                {{this.$t('storeToolMgnView.tipsEgA2')}}<br/>
                <strong>{{this.$t('storeToolMgnView.tipsTitleB')}}</strong>{{this.$t('storeToolMgnView.tipsTitleTxtB')}}<br/>
                {{this.$t('storeToolMgnView.tipsEgB1')}}<br/>
                {{this.$t('storeToolMgnView.tipsEgB2')}}<br/>
            </div>
            <m-table
                :loading="storeToolMgnTable_loading"
                :columns="storeToolMgnTable_columns"
                :data="storeToolMgnTable_data"
                style="margin: 10px 5px;"
            ></m-table>
        </Card>
        <!-- 批量导入 -->
        <Modal
            v-model="modalStoreToolBatchLoadIn"
            :title="modalStoreToolBatchLoadIn_title"
            @on-ok="modalStoreToolBatchLoadIn_ok"
            width="550"
            :mask-closable="false"
        >
            <Steps :current="current" style="margin-left: 20px;">
                <Step :title="step1"></Step>
                <Step :title="step2"></Step>
                <Step :title="step3"></Step>
            </Steps>
            <div align="center" :style="step1_style">
                <br/><br/>
                <label>{{this.$t('storeToolMgnModel.warnInfo_downloadtemp')}}</label>
                <br/><br/>
                <Button type="primary" @click="tempdownloadClick">{{this.$t('storeToolMgnModel.tempdownload')}}</Button>
            </div>
            <div align="center" :style="step2_style">
                <br/><br/>
                <Row type="flex">
                    <Col span="3">
                    </Col>
                    <Col span="13">
                        <div align="right">
                            <label>{{this.$t('storeToolMgnModel.warnInfo_selectfile')}}</label>
                        </div>
                    </Col>
                    <Col span="8">
                        <Upload
                            :show-upload-list="false"
                            ref="batchLoadInFile_ref1"
                            :before-upload="handleBatchLoadInFileUpload"
                            :on-error="batchLoadInFileErrorUpload"
                            :on-success="batchLoadInFileSuccessUpload"
                            :action="uploadBatchLoadInFileUrl+'&vendorId='+vendorId+'&isSubmit=N&txnDate='+this.dateFormat(new Date())+'&vendorCode='+vendorCode+'&orgCode='+orgCode.join(',')">
                            <Button type="ghost" size="small" :disabled="batchLoadInFileUpload_disabled">{{
                                this.$t('common.toUpload') }}
                            </Button>
                        </Upload>
                        <Upload
                            style="display: none;"
                            :show-upload-list="false"
                            ref="batchLoadInFile_ref2"
                            :before-upload="handleBatchLoadInFileUpload"
                            :on-error="batchLoadInFileErrorUpload"
                            :on-success="batchLoadInFileSuccessUpload"
                            :action="uploadBatchLoadInFileUrl+'&vendorId='+vendorId+'&isSubmit=Y&txnDate='+this.dateFormat(new Date())+'&vendorCode='+vendorCode+'&orgCode='+orgCode.join(',')">
                        </Upload>
                    </Col>
                </Row>
                <br/>
                <div v-if="this.batchLoadInFile !== null">
                    {{this.$t('common.file')}}: {{ this.batchLoadInFile.name }}
                    &nbsp;
                    <Button type="primary" size="small" @click="batchLoadInFileToUpload"
                            :loading="this.batchLoadInFile_loadingStatus">{{
                        this.batchLoadInFile_loadingStatus ? this.$t('common.uploading') :
                        this.$t('storeToolMgnModel.startLoadBtn') }}
                    </Button>
                </div>
            </div>
            <div align="center" :style="step3_style">
                <br/><br/>
                <div>{{expResult}}</div>
                <br/>
                <Button @click="downResult" :loading="downLoading" type="primary">{{this.$t('storeToolMgnModel.resultExpBtn')}}</Button>
                <!-- <label>{{this.$t('storeToolMgnModel.warnInfo_viewResult')}}</label> -->
                <!--&nbsp;
                <Button type="primary">{{this.$t('storeToolMgnModel.resultExpBtn')}}</Button>
                --><br/>
                <!-- <Input type="textarea" readonly :value="expResult" :rows="3" style="width: 450px;"/> -->
            </div>
            <div slot="footer" align="center">
                <Tooltip :content="this.$t('storeToolMgnModel.close')" style="display: inline-block;">
                    <Button icon="close-circled" @click="modalStoreToolBatchLoadIn_cancel">{{this.$t('storeToolMgnModel.close')}}</Button>
                </Tooltip>
                &nbsp;
                <Tooltip :content="this.$t('storeToolMgnModel.upStep')" style="display: inline-block;">
                    <Button icon="arrow-left-c" @click="changeModalStoreToolBatchLoadInViewUp">{{this.$t('storeToolMgnModel.upStep')}}</Button>
                </Tooltip>
                &nbsp;
                <Tooltip v-if="this.current !== 1" :content="this.$t('storeToolMgnModel.nextStep')" style="display: inline-block;">
                    <Button :style="next_style" icon="arrow-right-c"
                            @click="changeModalStoreToolBatchLoadInViewNext">{{this.$t('storeToolMgnModel.nextStep')}}</Button>
                </Tooltip>
                &nbsp;
                <Tooltip v-if="this.successNumber >= 1" :content="this.$t('storeToolMgnModel.submit')" style="display: inline-block;">
                    <Button :style="ok_style" icon="checkmark-circled" @click="modalStoreToolBatchLoadIn_ok"
                            :loading="submitOKBtnLoading">{{this.$t('storeToolMgnModel.submit')}}</Button>
                </Tooltip>
            </div>
        </Modal>
        <!-- 多档位库存录入功能 -->
        <Modal v-model="uploadModal" class="uploadModalClass" :width="500" :mask-closable="false" @on-cancel="handleCancel">
            <h3 slot="header" class="clearfix">
               <span class="pull-left" style="line-height: 45px;font-size: 16px;">{{this.$t('storeToolMgnModel.modalStoreToolBatchLoadIn_title')}}</span>
               <div class="step-header">
                    <div class="step-bar">
                      <div class="step-bar-active" id="step-bar-active"></div>
                    </div>
                    <ul>
                      <li class="active"><span></span>
                        <p>{{this.$t('storeToolMgnView.templateDownload')}}</p></li>
                      <li v-if="current2 >= 1" class="active"><span></span>
                        <p>{{this.$t('storeToolMgnView.dataLoadIn')}}</p></li>
                      <li v-else><span></span>
                        <p>{{this.$t('storeToolMgnView.dataLoadIn')}}</p></li>
                      <li v-if="current2 >= 2" class="active"><span></span>
                        <p>{{this.$t('storeToolMgnView.resultSubmit')}}</p></li>
                      <li v-else><span></span>
                        <p>{{this.$t('storeToolMgnView.resultSubmit')}}</p></li>
                    </ul>
                </div>
            </h3>
            <div v-if="current2 === 0" class="step-container">
                <p class="form-item-tip">{{this.$t('storeToolMgnModel.warnInfo_downloadtemp')}}</p>
                <div class="text-center">
                    <Button type="primary" @click="handleDowloadTemplate()">{{this.$t('storeToolMgnModel.tempdownload')}}</Button>
                </div>
            </div>
            <div v-else-if="current2 === 1" class="step-container">
                <Upload class="text-center"
                    ref="upload1"
                    :on-success="handleSuccess"
                    :on-error="handleError"
                    :action="uploadFileUrl">
                    <Button type="ghost" icon="ios-cloud-upload-outline" :loading="this.uploadFileLoading">{{this.$t('storeToolMgnModel.uploadFile')}}</Button>
                </Upload>
            </div>
            <div v-else-if="current2 === 2" class="step-container">
                <div class="form-item-tip">
                    <h3 v-if="downInportResultObj.sourceToken">{{this.$t('storeToolMgnModel.importCompleteClick')}}<span style="cursor:pointer;color:red" @click="downInportResult">{{this.$t('common.download')}}</span>{{this.$t('storeToolMgnModel.downInportResult')}}</h3>
                    <span>{{excelImportTips}}</span>
                </div>
            </div>
            <div slot="footer">
                <m-button v-if="current2 > 0 && current2 < 2" @click="prev">{{this.$t('storeToolMgnModel.upStep')}}</m-button>
                <m-button v-if="current2 < 2" type="primary" @click="next">{{this.$t('storeToolMgnModel.nextStep')}}</m-button>
                <m-button v-else type="success" @click="handleComplete">{{this.$t('storeToolMgnModel.complete')}}</m-button>
            </div>
        </Modal>
        <Modal
            v-model="modalMaterialCode"
            :title="modalMaterialCode_title"
            @on-ok="modalMaterialCode_ok"
            @on-cancel="modalMaterialCode_cancel" width="850"
            :mask-closable="false"
        >
            <slot name='body' style='text-align:center'>
                <Row type="flex" justify="center" class="code-row-bg">
                    <Col span="2" class="txt1">
                        <label>{{this.$t('storeToolMgnTable.materialCode')}}</label></Col>
                    <Col span="8">
                        <Input style="width:200px" v-model="modalMaterialCode_qry_materialCode"/></Col>
                    <Col span="5">
                        <Button @click="modalMaterialCode_queryBtn" type="primary" icon="ios-search">
                            {{this.$t('storeToolMgnView.searchBtn')}}
                        </Button>
                    </Col>
                </Row>
                <Table height="200" highlight-row border
                       :loading="materialCodeTable_loading"
                       :columns="materialCodeTable_columns"
                       :data="materialCodeTable_data"
                       @on-select="materialCodeTable_OnSelect"
                       @on-select-cancel="materialCodeTable_OnSelectCancel"
                       @on-select-all="materialCodeTable_OnSelectAll"
                       @on-selection-change="materialCodeTable_OnSelectionChange"
                       style="margin: 10px 5px"
                ></Table>
            </slot>
        </Modal>
    </div>
</template>
<script>
    import mTable from '@/components/awesome/page/table/index.js';
    import axios from 'axios';
    import {request} from '@/utils/index';
    // import api from '@/modules/gsc/api';
    import moment from 'moment';

    export default {
        components: {mTable},
        data() {
            return {
                CUX_INV_FILE_SIZElist: [
                    {
                        value: 100
                    }
                ],
                downLoading: false,
                successNumber: '',
                batchNumber: '',
                isPlanQuantityVal: '',
                // mbDocId: api.StoreToolMgnViewTemplateFile,
                qryConForm: {
                    Labels: {
                        storeOrg: this.$t('storeToolMgn_qryConForm.storeOrg'),
                        createDate: this.$t('storeToolMgn_qryConForm.createDate'),
                        commentTxt: this.$t('storeToolMgn_qryConForm.commentTxt')
                    }
                },
                storeOrg: '',
                createDate: '',
                commentTxt: '',
                qryConForm_storeOrgList: [],
                selectValue: [], // 交易类型下拉框的数组
                saveStoreLoading: false, // 保存按钮loading事件
                storeToolMgnTable_loading: false,
                storeToolMgnTable_columns: {
                    showCheckbox: false,
                    showButtons: false,
                    columns: [
                        {
                            title: this.$t('storeToolMgnView.sequence'),
                            type: 'index',
                            width: 50,
                            align: 'center'
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('div', [
                                    h('Label', {
                                        style: {
                                            color: 'red',
                                            padding: '5px'
                                        }
                                    }, '*'),
                                    h('span', {
                                        style: {
                                            padding: '5px'
                                        }
                                    }, this.$t('storeToolMgnTable.materialCode'))
                                ]);
                            },
                            key: 'materialCode',
                            sortable: false,
                            align: 'center',
                            render: (h, params) => {
                                return h('div', [
                                    h('Input', {
                                        props: {
                                            value: params.row.materialCode,
                                            readonly: false
                                        },
                                        style: {
                                            width: '140px',
                                            padding: '5px'
                                        },
                                        on: {
                                            input: (event) => {
                                                this.materialCodeTable_data_selectItem = [];
                                                this.RowIndex = params.index;
                                                this.storeToolMgnTable_data[this.RowIndex].materialDesc = '';
                                                this.storeToolMgnTable_data[this.RowIndex].unit = '';
                                                this.inputEventMaterialCode_query(event);
                                            }
                                        }
                                    }),
                                    h('Button', {
                                        props: {
                                            icon: 'search'
                                        },
                                        style: {
                                            width: '33px',
                                            padding: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.modalMaterialCode = true;
                                                this.modalMaterialCode_qry_materialCode = '';
                                                this.materialCodeTable_data = [];
                                                this.materialCodeTable_data_selectItem = [];
                                                this.materialCodeTable_loading = false;
                                                this.RowIndex = params.index;
                                            }
                                        }
                                    })
                                ]);
                            },
                            minWidth: 180
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('span', this.$t('storeToolMgnTable.materialDesc'));
                            },
                            key: 'materialDesc',
                            sortable: false,
                            align: 'center',
                            render: (h, params) => {
                                return h('div', [
                                    h('Input', {
                                        props: {
                                            type: 'textarea',
                                            value: params.row.materialDesc,
                                            readonly: true,
                                            rows: 1
                                        },
                                        style: {
                                            minWidth: '170px',
                                            padding: '5px'
                                        }
                                    })
                                ]);
                            },
                            minWidth: 180
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('span', this.$t('storeToolMgnTable.unit'));
                            },
                            key: 'unit',
                            sortable: false,
                            align: 'center',
                            render: (h, params) => {
                                return h('div', [
                                    h('Input', {
                                        props: {
                                            value: params.row.unit,
                                            readonly: true
                                        },
                                        style: {
                                            minWidth: '60px',
                                            padding: '5px'
                                        }
                                    })
                                ]);
                            },
                            minWidth: 80
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('div', [
                                    h('Label', {
                                        style: {
                                            color: 'red',
                                            padding: '5px'
                                        }
                                    }, '*'),
                                    h('span', {
                                        style: {
                                            padding: '5px'
                                        }
                                    }, this.$t('storeToolMgnTable.transactionType')) // 交易类型
                                ]);
                            },
                            key: 'makeOrderStatus',
                            width: 140,
                            align: 'center',
                            render: (h, param) => {
                                let options = [];
                                this.selectValue.forEach((item, index) => {
                                    options.push(h('Option', {props: {label: item.label, value: item.value}}));
                                });
                                return h('Select', {
                                    props: {
                                        value: param.row.makeOrderStatus,
                                        disabled: false,
                                        size: 'small'
                                    },
                                    on: {
                                        'on-change': (selection) => {
                                            this.count_store.count[param.index].value = '';
                                            param.row.count = '';
                                            this.storeToolMgnTable_data[param.row.index] = param.row;
                                            this.storeToolMgnTable_data[param.row._index].makeOrderStatus = selection;
                                        }
                                    }
                                }, options);
                            }
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('div', [
                                    h('Label', {
                                        style: {
                                            color: 'red',
                                            padding: '5px'
                                        }
                                    }, '*'),
                                    h('span', {
                                        style: {
                                            padding: '5px'
                                        }
                                    }, this.$t('storeToolMgnTable.count')) // '数量'
                                ]);
                            },
                            key: 'count',
                            sortable: false,
                            align: 'center',
                            render: (h, params) => {
                                if (this.count_store.count.length === 0 || this.count_store.count.length === params.index) {
                                    this.count_store.count.push({rowIndex: params.index, value: params.row.count});
                                }
                                return h('div', [
                                    h('Input', {
                                        props: {
                                            value: this.count_store.count[params.index].value,
                                            maxlength: 14,
                                            readonly: false,
                                            disabled: !params.row.makeOrderStatus
                                        },
                                        style: {
                                            minWidth: '110px',
                                            padding: '5px'
                                        },
                                        on: {
                                            'on-blur': (event) => {
                                                // 整数位最多8位，小数位最多5位
                                                let rule1 = /^[1-9]\d{0,7}(\.\d{1,5})?$|^0(\.\d{1,5})?$/; // 录入现有量 （不允许负数）
                                                let rule2 = /^(-)?[1-9]\d{0,7}(\.\d{1,5})?$|^(-)?0(\.\d{1,5})?$/; // 录入入库/ 出库 （允许负数）
                                                let rule = '';
                                                if (params.row.makeOrderStatus === 'RS_TXN') {
                                                    rule = rule1;
                                                } else {
                                                    rule = rule2;
                                                }
                                                if (!rule.test(event.target.value)) {
                                                    event.target.value = '';
                                                    this.count_store.count[params.index].value = '';
                                                    params.row.count = '';
                                                    this.storeToolMgnTable_data[params.index] = params.row;
                                                    this.$Modal.error({
                                                        title: this.$t('common.warn'),
                                                        content: this.$t('storeToolMgnTable.tips1')}); // '请输入整数位不能超过8位，小数位不能超过5位的数字'
                                                } else {
                                                    this.count_store.count[params.index].value = event.target.value;
                                                }
                                            }
                                        }
                                    })
                                ]);
                            },
                            minWidth: 120
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('span', this.$t('storeToolMgnTable.comment'));
                            },
                            key: 'comment',
                            sortable: false,
                            align: 'center',
                            render: (h, params) => {
                                if (this.comment_store.comment.length === 0 || this.comment_store.comment.length === params.index) {
                                    this.comment_store.comment.push({
                                        rowIndex: params.index,
                                        value: params.row.comment
                                    });
                                }
                                return h('div', [
                                    h('Input', {
                                        props: {
                                            type: 'textarea',
                                            value: this.comment_store.comment[params.index].value,
                                            rows: 1
                                        },
                                        style: {
                                            minWidth: '200px',
                                            padding: '5px'
                                        },
                                        on: {
                                            input: (event) => {
                                                this.comment_store.comment[params.index].value = event;
                                            }
                                        }
                                    })
                                ]);
                            },
                            minWidth: 220
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('span', this.$t('storeToolMgnTable.opt'));
                            },
                            key: 'opt',
                            sortable: false,
                            align: 'center',
                            render: (h, params) => {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            icon: 'close-circled'
                                        },
                                        style: {
                                            width: '33px',
                                            padding: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.storeToolMgnTable_data.splice(params.index, 1);
                                                this.comment_store.comment.splice(params.index, 1);
                                                this.count_store.count.splice(params.index, 1);
                                            }
                                        }
                                    })
                                ]);
                            },
                            minWidth: 50
                        }
                    ]
                },
                createDateList: [],
                storeToolMgnTable_data: [],
                RowIndex: -1,
                count_store: {
                    count: []
                },
                comment_store: {
                    comment: []
                },
                current: 0,
                step1: this.$t('storeToolMgnView.templateDownload'),
                step2: this.$t('storeToolMgnView.dataLoadIn'),
                step3: this.$t('storeToolMgnView.resultSubmit'),
                modalStoreToolBatchLoadIn: false,
                modalStoreToolBatchLoadIn_title: this.$t('storeToolMgnModel.modalStoreToolBatchLoadIn_title'),
                step1_style: '',
                step2_style: 'display:none;',
                step3_style: 'display:none;',
                next_style: '',
                ok_style: 'display:none;',
                uploadBatchLoadInFileUrl: '/gscapp/storeTool/loadDataInOfVendorMtlTransactions?fields=index,organization_code,item_number,inventoryType,txn_qty,txn_reference',
                batchLoadInFileUpload_disabled: false,
                batchLoadInFile: null,
                batchLoadInFile_loadingStatus: false,
                vendorId: null,
                vendorCode: null,
                modalMaterialCode: false,
                modalMaterialCode_title: this.$t('storeToolMgnModel.modalMaterialCode_title'),
                modalMaterialCode_qry_materialCode: '',
                materialCodeTable_loading: false,
                materialCodeTable_columns: [
                    {
                        title: this.$t('storeToolMgnView.sequence'),
                        type: 'index',
                        align: 'center',
                        width: 60
                    },
                    {
                        type: 'selection',
                        title: this.$t('common.chooseBtn'),
                        align: 'center',
                        minWidth: 60
                    },
                    {
                        title: this.$t('storeToolMgnTable.materialCode'),
                        key: 'materialCode',
                        minWidth: 200
                    },
                    {
                        title: this.$t('storeToolMgnTable.materialDesc'),
                        key: 'materialDesc',
                        minWidth: 320
                    },
                    {
                        title: this.$t('storeToolMgnTable.unit'),
                        key: 'unit',
                        minWidth: 150
                    }
                ],
                materialCodeTable_result: {},
                materialCodeTable_data: [],
                materialCodeTable_data_selectItem: [],
                expResult: '',
                isSubmit: 'N',
                orgCode: [],
                showBtn: true,
                needValidate: false,
                submitOKBtnLoading: false,
                /** 多档位库存导入 */
                CUX_JD_ORGlist: [],
                showBtn2: false,
                uploadModal: false,
                current2: 0,
                uploadFileUrl: '',
                downInportResultObj: {
                    sourceToken: '',
                    fileName: ''
                },
                uploadFileLoading: false,
                userName: null,
                // mbDocId2: api.StoreToolMgnViewTemplateFile2,
                responseData: {},
                excelImportTips: ''
            };
        },
        mounted() {
            this.getTransactionType();
            var yesterDayTime = new Date();
            yesterDayTime.setTime(yesterDayTime.getTime() - 24 * 60 * 60 * 1000);
            var currentDayTime = new Date();
            currentDayTime.setTime(currentDayTime.getTime());
            this.createDateList = [];
            this.createDateList.push({
                    value: this.dateFormat(currentDayTime),
                    label: this.dateFormat(currentDayTime)
                },
                {
                    value: this.dateFormat(yesterDayTime),
                    label: this.dateFormat(yesterDayTime)
                });
            this.createDate = this.dateFormat(currentDayTime);
            this.getVendorId();
            this.getCode('CUX_JD_ORG', 'CUX_JD_ORGlist'); // 按照快码CUX_JD_ORG机电事业部库存组织,控制是否使用_多档位库存录入功能
            this.getCode('CUX_INV_FILE_SIZE', 'CUX_INV_FILE_SIZElist');
        },
        watch: {
            materialCodeTable_result: function () {
                this.materialCodeTable_data = [];
                if (this.materialCodeTable_result.errorCode === 200) {
                    let dataHandle = this.materialCodeTable_result.result.list;
                    let len = dataHandle.length;
                    let obj = null;
                    for (var i = 0; i < len; i++) {
                        obj = dataHandle[i];

                        this.materialCodeTable_data.push(
                            {
                                _checked: false,
                                materialCode: obj.MATERIALCODE,
                                materialDesc: obj.MATERIALDESC,
                                unit: obj.UNIT
                            }
                        );
                    }
                } else {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('storeToolMgnModel.errorStatus')
                    });
                }
                this.materialCodeTable_loading = false;
            }
        },
        methods: {
            getNewDate () {
                return moment().format('YYYY-MM-DD HH:mm:ss');
            },
            getVendorId() {
                axios.get('/gscint/vendor/getCurrentVendor', {
                    params: {}
                }).then(res => {
                    this.vendorId = res.data.data.vendorId;
                    this.vendorCode = res.data.data.vendorCode;
                    this.userName = res.data.data.userName;

                    if (this.vendorId === '' || this.vendorId === undefined) {
                        this.$Message.error(this.$t('common.reload'));
                    }
                    this.qryConForm_storeOrg_fillData();
                });
            },
            actionUrl() {
                this.uploadFileUrl = `/gscapp/multiPGI/loadDataMultiPGI?txnDate=${moment(new Date()).format('YYYY-MM-DD')}&vendorId=${this.vendorId}&vendorCode=${this.vendorCode}&operatorName=${this.userName}&orgId=${this.storeOrg}`;
            },
            qryConForm_storeOrg_fillData() {
                this.qryConForm_storeOrgList = [];
                axios.get('/gscapp/lov/getSRMInvLovListNew?UP=Y&SITE=Y&ASL=N', {
                    params: {}
                }).then(res => {
                    let handlerResult = res.data.data;
                    let len = handlerResult.length;
                    let obj = null;
                    for (var i = 0; i < len; i++) {
                        obj = handlerResult[i];
                        this.qryConForm_storeOrgList.push({
                            label: obj.organizationName,
                            value: obj.erpOrgId,
                            organization_code: obj.organizationCode
                        });
                        this.orgCode.push(obj.organizationCode);
                    }
                });
            },
            batchLoadBtnClick_openModal() {
                this.modalStoreToolBatchLoadIn = true;
                this.batchLoadInFile = null;
                this.batchLoadInFile_loadingStatus = false;
                this.batchLoadInFileUpload_disabled = false;
                this.expResult = '';
                this.current = 1;
                this.changeModalStoreToolBatchLoadInViewUp();
            },
            validIfCanAddOpt() {
                if (this.isEmptyValue(this.storeOrg)) {
                    this.$Message.warning(this.$t('storeToolMgnTable.plsSelectOrganizationName'));
                    return false;
                }
                if (this.isEmptyValue(this.createDate)) {
                    this.$Message.warning(this.$t('storeToolMgnTable.plsSelectCreateDate'));
                    return false;
                }
                return true;
            },
            isEmptyValue(value) {
                if (value === null || value === 'null' || value === undefined || value === 'undefined' || value === '') {
                    return true;
                }
                return false;
            },
            addBtnClick() {
                if (this.validIfCanAddOpt()) {
                    this.storeToolMgnTable_data.push(
                        {
                            materialCode: '',
                            materialDesc: '',
                            unit: '',
                            count: '',
                            comment: this.commentTxt,
                            opt: '',
                            makeOrderStatus: ''
                        });
                }
            },
            saveBtnClick() {
                this.saveStoreLoading = true;
                if (this.validIfCanAddOpt()) {
                    if (!this.validateStoreToolMgnTable()) {
                        this.saveStoreLoading = false;
                        return;
                    }
                    if (!this.validateNum()) {
                        this.saveStoreLoading = false;
                        // this.$Message.error(this.$t('数量不能为负数或者0'));
                        return false;
                    }
                    console.log('!!this.storeToolMgnTable_data::', this.storeToolMgnTable_data);
                    let len = this.storeToolMgnTable_data.length;
                    let jsonVendorMtlTransactions = [];
                    let obj = null;
                    for (var i = 0; i < len; i++) {
                        obj = this.storeToolMgnTable_data[i];
                        jsonVendorMtlTransactions.push({
                            item_number: obj.materialCode, // 物料编码
                            item_description: obj.materialDesc, // 物料描述
                            item_uom: obj.unit, // 单位
                            txn_qty: obj.count, // 数量
                            txn_reference: obj.comment, // 备注
                            inventoryType: obj.makeOrderStatus // 交易类型
                        });
                    }

                    let storeOrgVal = '';
                    obj = null;
                    len = this.qryConForm_storeOrgList.length;
                    for (i = 0; i < len; i++) {
                        obj = this.qryConForm_storeOrgList[i];
                        if (obj.value === this.storeOrg) {
                            storeOrgVal = obj.organization_code;
                            break;
                        }
                    }
                    let isPlanQuantityTag = this.isPlanQuantityVal === false ? 'Y' : 'N';
                    axios.post('/gscapp/storeTool/saveStoreToolData', {
                        jsonVendorMtlTransactions: JSON.stringify(jsonVendorMtlTransactions),
                        storeOrg: storeOrgVal,
                        vendorId: this.vendorId,
                        txnDate: moment().format('YYYY-MM-DD HH:mm:ss'),
                        vendorCode: this.vendorCode,
                        isPlanQuantity: isPlanQuantityTag
                    }, this.postHeaderConf).then(res => {
                        if (res.data.success === true) {
                            if (res.data.data.success === true) {
                                this.saveStoreLoading = false;
                                this.$Message.success(this.$t('common.save_success'));
                                this.storeToolMgnTable_data = [];
                                this.comment_store.comment = [];
                                this.count_store.count = [];
                            } else {
                                this.saveStoreLoading = false;
                                this.$Modal.error({
                                    title: this.$t('common.warn'),
                                    content: res.data.data.errorMsg
                                });
                            }
                        } else {
                            this.saveStoreLoading = false;
                            this.$Modal.error({
                                title: this.$t('common.warn'),
                                content: this.$t('common.error1')
                            });
                        }
                    }).catch(err => {
                        this.saveStoreLoading = false;
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('common.error1'),
                            error: err.stack.toString()
                        });
                    });
                } else {
                    this.saveStoreLoading = false;
                }
            },
            tempdownloadClick() {
                // window.open('/gscint/supplierfile/downloadFile?docId=' + this.mbDocId);
            },
            modalStoreToolBatchLoadIn_ok() {
                this.submitOKBtnLoading = true;
                this.isSubmit = 'Y';
               // this.batchLoadInFileToUpload();
                this.saveFile();
            },
            saveFile() {
                let url = '/gscapp/storeTool/insertTempInOutBill?batchNumber=' + this.batchNumber + '&vendorCode=' + this.vendorCode;
                axios.get(url).then(res => {
                    console.log(res);
                    this.submitOKBtnLoading = false;
                    if (res.data.success === true) {
                        this.modalStoreToolBatchLoadIn = false;
                        this.$Message.success(this.$t('common.save_success'));
                    } else {
                        this.$Message.error(res.data.msg);
                    }
                });
            },
            modalStoreToolBatchLoadIn_cancel() {
                this.modalStoreToolBatchLoadIn = false;
            },
            changeModalStoreToolBatchLoadInViewUp() {
                if (this.current === 0) {
                    return;
                }

                this.current = this.current - 1;
                if (this.current === 0) {
                    this.step1_style = '';
                    this.step2_style = 'display:none;';
                    this.step3_style = 'display:none;';
                } else if (this.current === 1) {
                    this.step1_style = 'display:none;';
                    this.step2_style = '';
                    this.step3_style = 'display:none;';
                } else if (this.current === 2) {
                    this.step1_style = 'display:none;';
                    this.step2_style = 'display:none;';
                    this.step3_style = '';
                }

                this.next_style = '';
                this.ok_style = 'display:none;';
            },
            changeModalStoreToolBatchLoadInViewNext() {
                if (this.current === 3) {
                    return;
                }

                this.current = this.current + 1;
                if (this.current === 1) {
                    this.step1_style = 'display:none;';
                    this.step2_style = '';
                    this.step3_style = 'display:none;';

                    this.next_style = '';
                    this.ok_style = 'display:none;';
                } else if (this.current === 2) {
                    this.step1_style = 'display:none;';
                    this.step2_style = 'display:none;';
                    this.step3_style = '';

                    this.next_style = 'display:none;';
                    this.ok_style = '';
                } else if (this.current === 3) {
                    this.step1_style = 'display:none;';
                    this.step2_style = 'display:none;';
                    this.step3_style = 'display:none;';
                }
            },
            handleBatchLoadInFileUpload(file) {
                let size = parseInt(this.CUX_INV_FILE_SIZElist[0].value);
                if (file.size / 1024 > size) {
                    this.$Modal.error({
                        content: this.$t('storeToolMgnModel.fileSizeTips1') + `${size}KB` + this.$t('storeToolMgnModel.fileSizeTips2') // `导入文件大小不能超过${size}KB，请修改后重新导入`
                    });
                    return false;
                }
                this.submitOKBtnLoading = true;
                console.log('Loading开始：', true);
                this.batchLoadInFile = file;
                this.isSubmit = 'N';
                return false;
            },
            batchLoadInFileToUpload() {
                if (this.batchLoadInFile.name.indexOf('.xlsx') === -1 && this.batchLoadInFile.name.indexOf('.xls') === -1) {
                    this.$Message.error(this.$t('storeToolMgnModel.fileTypeFormateError'));
                    return;
                }

                this.batchLoadInFile_loadingStatus = true;
                if (this.isSubmit === 'Y') {
                    this.$refs.batchLoadInFile_ref2.post(this.batchLoadInFile);
                } else if (this.isSubmit === 'N') {
                    this.$refs.batchLoadInFile_ref1.post(this.batchLoadInFile);
                }
                this.batchLoadInFileUpload_disabled = true;
            },
            batchLoadInFileSuccessUpload(response, file, fileList) {
                this.batchLoadInFile_loadingStatus = false;
                this.batchLoadInFileUpload_disabled = false;
                console.log(response.data.message);
                if (response.data.resultCode === 'success') {
                    this.submitOKBtnLoading = false;
                    if (this.isSubmit === 'Y') {
                        this.$Message.success(this.$t('common.save_success'));
                        this.modalStoreToolBatchLoadIn = false;
                    }
                    this.successNumber = response.data.success;
                    this.expResult = response.data.message;
                    this.batchNumber = response.data.batchNumber;
                } else if (response.data.resultCode === 'failed') {
                    this.submitOKBtnLoading = false;
                    this.expResult = response.data.errorMess;
                    this.isSubmit = 'N';
                }

                this.current = 1;
                this.changeModalStoreToolBatchLoadInViewNext();
            },
            batchLoadInFileErrorUpload(error, file, fileList) {
                this.submitOKBtnLoading = true;
                this.$Message.error(this.$t('common.upload_error'));
                error = null;
                this.batchLoadInFile_loadingStatus = false;
                this.batchLoadInFileUpload_disabled = false;
            },
            downResult() {
                this.downLoading = true;
                let url = '/gscapp/storeTool/excelTempInOutBill' + '?batchNumber=' + this.batchNumber;
                window.open(url);
                this.downLoading = false;
            },
            saveResult() {
            },
            validateStoreToolMgnTable() {
                let len = this.storeToolMgnTable_data.length;
                if (len === 0) {
                    return false;
                }
                for (var i = 0; i < len; i++) {
                    var countVal = this.count_store.count[i].value;
                    this.storeToolMgnTable_data[i].count = countVal;
                    var commentVal = this.comment_store.comment[i].value;
                    this.storeToolMgnTable_data[i].comment = commentVal;
                    if (this.isEmptyValue(this.storeToolMgnTable_data[i].materialCode) || this.isEmptyValue(countVal)) {
                        this.$Message.warning(this.$t('storeToolMgnTable.editTableRowRequired') + this.$t('storeToolMgnTable.validate_fail_detail') + ' ' + this.$t('storeToolMgnTable.rowIndex1') + ' ' + (i + 1) + ' ' + this.$t('storeToolMgnTable.rowIndex2'));
                        return false;
                    }
    
                    if (!this.isEmptyValue(countVal) && (isNaN(countVal))) {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('storeToolMgnTable.rowIndex1') + ' ' + (i + 1) + ' ' + this.$t('storeToolMgnTable.rowIndex2') + ' ' + this.$t('storeToolMgnTable.count') + this.$t('storeToolMgnTable.requireNumberVal')
                        });
                        return false;
                    }
                    if (this.storeToolMgnTable_data[i].makeOrderStatus === '') {
                        this.$Message.warning(this.$t('VendorRegist.vrcolumn34') + this.$t('storeToolMgnTable.transactionType'));
                        return false;
                    }
                }
                return true;
            },
            modalMaterialCode_ok() {
                this.modalMaterialCode_rollbackSet();
            },
            modalMaterialCode_cancel() {
                this.modalMaterialCode_qry_materialCode = '';
                this.materialCodeTable_loading = false;
            },
            modalMaterialCode_queryBtn() {
                this.materialCodeTable_loading = true;

                if (this.modalMaterialCode_qry_materialCode === '' || this.modalMaterialCode_qry_materialCode === undefined) {
                    this.modalMaterialCode_qry_materialCode = '';
                }

                let paramArr = [];
                paramArr.push({name: 'pageSize', value: 100});
                paramArr.push({name: 'pageIndex', value: 1});
                paramArr.push({name: 'vendorId', value: this.vendorId});
                paramArr.push({
                    name: 'organizationId',
                    value: this.storeOrg
                });
                paramArr.push({name: 'materialCode', value: this.modalMaterialCode_qry_materialCode});

                paramArr.push({name: 'countStatus', value: 'N'});
                request(api.modalMaterialCodeQuery, {'name': 'queryMaterialCode', 'parameter': paramArr}).then(res => {
                    this.materialCodeTable_result = res;
                }).catch(() => {
                    this.materialCodeTable_loading = false;
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('common.error1')
                    });
                });
            },
            inputEventMaterialCode_query(event) {
                this.storeToolMgnTable_loading = true;
                let paramArr = [];
                paramArr.push({name: 'pageSize', value: 100});
                paramArr.push({name: 'pageIndex', value: 1});
                paramArr.push({name: 'vendorId', value: this.vendorId});
                paramArr.push({
                    name: 'organizationId',
                    value: this.storeOrg
                });
                paramArr.push({name: 'materialCode', value: event});

                paramArr.push({name: 'countStatus', value: 'N'});
                request(api.modalMaterialCodeQuery, {'name': 'queryMaterialCode', 'parameter': paramArr}).then(res => {
                    let dataHandle = res.result.list;
                    let len = dataHandle.length;
                    let obj = null;
                    if (len === 1) {
                        obj = dataHandle[0];
                        this.materialCodeTable_data_selectItem.push({
                            materialCode: obj.MATERIALCODE,
                            materialDesc: obj.MATERIALDESC,
                            unit: obj.UNIT
                        });
                        this.modalMaterialCode_rollbackSet();
                    }
                    this.storeToolMgnTable_loading = false;
                });
                // .catch(() => {
                //     this.$Modal.error({
                //         title: this.$t('common.warn'),
                //         content: this.$t('common.error1')
                //     });
                // });
            },
            modalMaterialCode_rollbackSet() {
                var len = this.materialCodeTable_data_selectItem.length;
                if (len > 1) {
                    this.$Message.warning(this.$t('common.onlyOneChoose'));
                    return;
                }
                this.storeToolMgnTable_data[this.RowIndex].materialCode = this.materialCodeTable_data_selectItem[0].materialCode;
                this.storeToolMgnTable_data[this.RowIndex].materialDesc = this.materialCodeTable_data_selectItem[0].materialDesc;
                this.storeToolMgnTable_data[this.RowIndex].unit = this.materialCodeTable_data_selectItem[0].unit;
            },
            materialCodeTable_OnSelect(selection, row) {
                this.materialCodeTable_data_selectItem = [];
                for (var i = 0; i < selection.length; i++) {
                    this.materialCodeTable_data_selectItem.push({
                        materialCode: selection[i].materialCode,
                        materialDesc: selection[i].materialDesc,
                        unit: selection[i].unit
                    });
                }
            },
            materialCodeTable_OnSelectCancel(selection, row) {
                this.materialCodeTable_data_selectItem = [];
                for (var i = 0; i < selection.length; i++) {
                    this.materialCodeTable_data_selectItem.push({
                        materialCode: selection[i].materialCode,
                        materialDesc: selection[i].materialDesc,
                        unit: selection[i].unit
                    });
                }
            },
            materialCodeTable_OnSelectAll(selection) {
                this.materialCodeTable_data_selectItem = [];
                for (var i = 0; i < selection.length; i++) {
                    this.materialCodeTable_data_selectItem.push({
                        materialCode: selection[i].materialCode,
                        materialDesc: selection[i].materialDesc,
                        unit: selection[i].unit
                    });
                }
            },
            materialCodeTable_OnSelectionChange(selection) {
                this.materialCodeTable_data_selectItem = [];
                for (var i = 0; i < selection.length; i++) {
                    this.materialCodeTable_data_selectItem.push({
                        materialCode: selection[i].materialCode,
                        materialDesc: selection[i].materialDesc,
                        unit: selection[i].unit
                    });
                }
            },
            /* yyyy-MM-dd */
            dateFormat(value) {
                try {
                    return value.getFullYear() + '-' + (((value.getMonth() + 1) < 10) ? '0' + (value.getMonth() + 1) : (value.getMonth() + 1)) + '-' + ((value.getDate() < 10) ? '0' + value.getDate() : value.getDate());
                } catch (err) {
                    if (value === undefined || value === 'undefined' || value === null || value === 'null') {
                        return '';
                    } else {
                        return value;
                    }
                }
            },
            /** 根据该接口控制是否强控数量 **/
            getScheduleStatus: function () {
                let orgCode = this.qryConForm_storeOrgList.find(item => item.value === this.storeOrg).organization_code;
                let params = {
                    organizationCode: orgCode,
                    vendorCode: this.vendorCode
                };
                axios.post('/gscapp/storeTool/getScheduleStatus', params).then(
                    res => {
                        if (res.data.success === true) {
                            if (res.data.data.count > 0) {
                                this.needValidate = true;
                            } else {
                                this.needValidate = false;
                            }
                        } else {
                            this.$Modal.error({
                                title: this.$t('common.warn'),
                                content: res.data.msg
                            });
                        }
                    }
                ).catch(() => {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('common.error1')
                    });
                });
            },
            isPlanQuantity() {
                this.storeToolMgnTable_data = []; // 清空表格数据
                let orgCode = this.qryConForm_storeOrgList.find(item => item.value === this.storeOrg).organization_code;
                let params = {
                    organization_code: orgCode
                };
                axios.post('/gscapp/underStock/isPlanQuantity', params)
                .then(res => {
                    this.isPlanQuantityVal = res.data.data;
                    console.log('this.isPlanQuantityVal:', this.isPlanQuantityVal);
                });
            },
            /** 切换库存组织 **/
            changeOrg: function (val) {
                if (this.CUX_JD_ORGlist.find(item => item.value === this.storeOrg)) {
                    this.showBtn2 = true;
                    this.actionUrl();
                } else {
                    this.showBtn2 = false;
                }
                this.storeToolMgnTable_data = [];
                this.getScheduleStatus();
                this.isPlanQuantity();
            },
            /** 假如needValidate为true 代表启用了供方仓排产 启用了供方仓排产，那么做库存录入界面，选择：录入现有量点击保存不能成功,且需有提示信息：该组织下只能通过工单排产完工入库。选择 录入入库/出库，只能录入负数。 */
            /** 不启用供方仓排产的供应商，数量不能输入负数 */
            validateNum: function () {
                console.log('this.storeToolMgnTable_data:', this.storeToolMgnTable_data);
                if (this.needValidate) {
                    let canSave1 = true;
                    this.storeToolMgnTable_data.map((item) => {
                        if (item.makeOrderStatus === 'RS_TXN') { // 录入现有量
                            this.$Modal.warning({
                                title: this.$t('common.warn'),
                                content: this.$t('storeToolMgnTable.tips2') // '该组织下只能通过工单排产完工入库'
                            });
                            canSave1 = false;
                            return false;
                        } else if (item.makeOrderStatus === 'MA_TXN') { // 录入入库/出库
                            if (item.count >= 0) {
                                this.$Modal.warning({
                                    title: this.$t('common.warn'),
                                    content: this.$t('storeToolMgnTable.tips2') // '该组织下只能通过工单排产完工入库'
                                });
                                canSave1 = false;
                                return false;
                            } else {
                                canSave1 = true;
                                return false;
                            }
                        }
                    });
                    return canSave1;
                } else {
                    let canSave = true;
                    this.storeToolMgnTable_data.map((item) => {
                        if (item.makeOrderStatus === 'RS_TXN') {
                            if (item.count < 0) {
                                this.$Modal.warning({
                                    title: this.$t('common.warn'),
                                    content: this.$t('storeToolMgnTable.tips3') // '数量不能输入负数'
                                });
                                canSave = false;
                                return false;
                            }
                        }
                    });
                    return canSave;
                    // if (this.storeToolMgnTable_data.find(item => item.count > 0)) {
                    //     this.$Modal.warning({
                    //         title: this.$t('common.warn'),
                    //         content: this.$t('storeToolMgnTable.tips2') // '该组织下只能通过工单排产完工入库'
                    //     });
                    //     return false;
                    // } else {
                    //     return true;
                    // }
                    // return true;
                }
            },
            /** 获取交易类型下拉 **/
            getTransactionType: function () {
                axios.get('/gscint/sys/sysParam/queryDictionaryData?dictCode=transactionType&isValid=Y', {
                    params: {
                        dictCode: 'transactionType'
                    }
                }).then(res => {
                    let resp = res.data;
                    if (resp.success === true) {
                        resp.data.forEach((item, index) => {
                            if (item.value === 'RS_TXN' || item.value === 'MA_TXN') {
                                this.selectValue.push({
                                    value: item.value,
                                    label: item.label
                                });
                            }
                        });
                        console.log('this.selectValue::', this.selectValue);
                    } else {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: resp.msg
                        });
                    }
                }).catch(err => {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('common.error1'),
                        error: err.stack.toString()
                    });
                });
            },
            /** 多档位库存导入start */
            handleCancel() {
                this.current2 = 0;
            },
            handleComplete() {
                this.current2 = 0;
                this.uploadModal = false;
                var bar = document.querySelector('#step-bar-active');
                    bar.style.width = 0 + 'px';
            },
            prev() {
                this.current2--;
                var bar = document.querySelector('#step-bar-active');
                    bar.style.width = this.current2 * 125 + 'px';
            },
            next() {
                if (this.current2 < 1) {
                    this.current2++;
                    var bar = document.querySelector('#step-bar-active');
                    bar.style.width = this.current2 * 125 + 'px';
                }
            },
            // handleBeforeFileUpload(file) {
            //     this.batchLoadInFile = file;
            //     return false;
            // },
            handleSuccess (res, file, fileList) {
                if (res.success) {
                    if (res.data.errorMessage) {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: res.data.errorMessage
                        });
                        this.uploadModal = false;
                        this.$refs['upload1'].clearFiles();
                        this.current2--;
                    } else {
                        this.responseData = res.data;
                        this.downInportResultObj = {
                            fileName: file.name,
                            sourceToken: 'ok' // res.data.data
                        };
                        if (res.data.errorNum === 0 && res.data.successNum !== 0) {
                            this.excelImportTips = this.$t('storeToolMgnModel.excelImportTips1') + `${res.data.successNum}` + this.$t('storeToolMgnModel.excelImportTips2');
                            // this.excelImportTips = `本次有${res.data.successNum}条数据校验成功，0条检验失败`;
                        } else if (res.data.errorNum !== 0) {
                            this.excelImportTips = this.$t('storeToolMgnModel.excelImportTips3') + `${res.data.errorNum}` + this.$t('storeToolMgnModel.excelImportTips4');
                            // this.excelImportTips = `因本次存在${res.data.errorNum}条数据校验失败，导致0条数据导入成功`;
                        }
                        this.current2++;
                        var bar = document.querySelector('#step-bar-active');
                            bar.style.width = this.current2 * 125 + 'px';
                    }
                } else {
                    this.$refs['upload1'].clearFiles();
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: res.errorCode
                    });
                }
            },
            handleError (error, file, fileList) {
                this.uploadFileLoading = false;
                this.$Message.error(this.$t('common.upload_error'));
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('storeToolMgnModel.excelImportTips5') // 附件上传失败，请检查附件后重新上传！
                });
                console.log('error:', error);
            },
            handleDowloadTemplate() {
                // window.open('/gscint/supplierfile/downloadFile?docId=' + this.mbDocId2);
            },
            downInportResult () {
                var config = {
                    cpt: 'srm/multiPGIOut-uat.cpt',
                    data: this.responseData,
                    fileName: this.$t('storeToolMgnModel.excelImportTips6'), // 多档位库存导入结果
                    printType: 'diePay'
                };
                this.$mprint.exportExcel(config);
            }, // 多档位库存导入end
            /** 本地快码 */
            getCode (code, key) {
                axios.get(`/gscint/sys/sysParam/queryDictionaryData?dictCode=${code}&isValid=Y`)
                .then((res) => {
                    this[key] = res.data.data;
                });
            }
        }
    };
</script>
<style lang='less' scoped>
    .step-header {
        width: 310px;
        padding: 0 10px 0 30px;
        float: right;
        position: relative;
        overflow: hidden;
        margin-right: 10px;
        ul {
            padding: 0;
            width: 375px;
            float: left;
            position: relative;
            li {
                list-style-type: none;
                float: left;
                position: relative;
                width: 125px;
                &.active {
                    span {
                        background: #2d8cf0;
                    }
                    p {
                        color: #333333;
                    }
                }
                p {
                    font-weight: bold;
                    margin-top: 5px;
                    font-size: 13px;
                    color: #999999;
                    float: left;
                    position: relative;
                    left: -50%;
                    text-align: center;
                    width: 125px;
                }
                span {
                    position: relative;
                    height: 20px;
                    width: 20px;
                    border-radius: 10px;
                    background: #ccc;
                    left: -10px;
                    display: block;
                }
            }
        }
    }
    
    .step-bar {
        width: 250px;
        height: 13px;
        background: #ccc;
        position: absolute;
        border-radius: 12px;
        top: 4px;
        overflow: hidden;
    }
    
    .step-bar-active {
        width: 0px;
        height: 13px;
        background: #2d8cf0;
    }
    .form-item-tip{
        text-align: center;
        margin-bottom: 10px;
    }
    .step-container{
        width: 450px;
        margin: 0 auto;
        padding:10px 0;
        .success-info{
            font-weight: 700;
            font-size: 14px;
            padding: 30px 0 50px 0;
            border-bottom: 1px solid #ccc ;
            color: #2A3C59;
        }
        .success-tip{
            font-weight: 600;
            font-size: 12px;
            padding: 15px 0 20px 0;
            color: #666;
        }
    }
</style>
<style lang='less'>
    .uploadModalClass {
        .m-modal-body {
            padding: 0;
        }
        .m-modal-footer {
            padding: 0px 18px 10px;
        }
    }
</style>